import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import RTVDialog from './RTVDialog';
import RtvButton from '../Buttons/RtvButton';
import LogoRTVPlus from '../../images/Logos/Logo_RTCplus.svg';

const useStyles = makeStyles(theme => ({
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem'
  },
  logo: {
    backgroundColor: '#000',
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: '8px'
  },
  logoImg: {
    height: '3em',
    width: 'auto',
    display: 'block'
  },
  title: {
    fontWeight: 600,
    fontSize: '1.25rem',
    color: '#E76262'
  },
  message: {
    color: '#000000',
    fontSize: '0.95rem'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  extra: {
    color: '#000000',
    fontSize: '0.85rem'
  },
  button: {
    minWidth: 120,
    borderRadius: 24
  }
}));

const dialogProps = {
  PaperProps: { style: { minWidth: 500 } }
};

const RTVPlusDialog = ({ open, onClose, isSubscribed = false }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('rtvPlus');

  const handleSubscribe = () => {
    onClose();
    history.push('/configuracion/rtcplus');
  };

  if (isSubscribed) {
    return (
      <RTVDialog
        open={open}
        onClose={onClose}
        dialogProps={dialogProps}
        noTitle
        noActionSection
        content={
          <div className={classes.contentWrapper}>
            <div className={classes.logo}>
              <img
                src={LogoRTVPlus}
                alt="RTVplus+"
                className={classes.logoImg}
              />
            </div>
            <Typography className={classes.message}>
              {t('dialog.alreadyMember')}
            </Typography>
            <RtvButton
              variant="rtvRed"
              onClick={onClose}
              className={classes.button}
            >
              {t('ok')}
            </RtvButton>
          </div>
        }
      />
    );
  }

  return (
    <RTVDialog
      open={open}
      onClose={onClose}
      dialogProps={dialogProps}
      noTitle
      noActionSection
      content={
        <div className={classes.contentWrapper}>
          <div className={classes.logo}>
            <img src={LogoRTVPlus} alt="RTVplus+" className={classes.logoImg} />
          </div>
          <Typography className={classes.message}>
            {t('dialog.promotedProduct')}
          </Typography>
          <div className={classes.buttonContainer}>
            <RtvButton
              variant="rtvRed"
              onClick={handleSubscribe}
              className={classes.button}
            >
              {t('dialog.tryItCta')}
            </RtvButton>
            <Typography className={classes.extra}>
              {t('dialog.limitedSpots')}
            </Typography>
          </div>
        </div>
      }
    />
  );
};

export default RTVPlusDialog;
